<template>
  <footer :class="[$style.footer]">
    <p :class="[$style.footerItem]">
      Deed s.r.l. – P.IVA 11547580016<span :class="[$style.hideMobile]"> – </span><a href="https://www.iubenda.com/privacy-policy/88693273" target="_blank" rel="noopener">Privacy</a> & <a href="https://www.iubenda.com/privacy-policy/88693273/cookie-policy" target="_blank" rel="noopener">Cookies</a>
    </p>
    <div :class="[$style.footerItem]">
      <div :class="[$style.socials]">
        <div :class="[$style.socialsWrapper]">
          <div :class="[$style.socialsItem]">
            <a href="https://www.facebook.com/getwearable/"  target="_blank" rel="noopener">
              <svg viewBox="0 0 74 136" id="facebook" xmlns="http://www.w3.org/2000/svg">
                <path d="M69.9 1.9H52.5c-19.5 0-32.2 13-32.2 33v15.2H2.8c-1.5 0-2.7 1.2-2.7 2.7v22c0 1.5 1.2 2.7 2.7 2.7h17.5v55.6c0 1.5 1.2 2.7 2.7 2.7h22.8c1.5 0 2.7-1.2 2.7-2.7V77.6H69c1.5 0 2.7-1.2 2.7-2.7v-22a2.732 2.732 0 0 0-2.7-2.7H48.6v-13c0-6.2 1.5-9.3 9.5-9.3h11.7c1.5 0 2.7-1.2 2.7-2.7V4.7c.1-1.5-1.1-2.7-2.6-2.8z"/>
              </svg>
            </a>
          </div>
          <div :class="[$style.socialsItem]">
            <a href="https://www.instagram.com/getwearable/"  target="_blank" rel="noopener">
              <svg viewBox="0 0 136 136" id="instagram" xmlns="http://www.w3.org/2000/svg">
                <path d="M97.9.8H37.3C16.7.8 0 17.5 0 38.1v60.6C0 119.3 16.7 136 37.3 136h60.6c20.6 0 37.3-16.7 37.3-37.3V38.1C135.2 17.5 118.5.8 97.9.8zm25.3 97.9c0 14-11.4 25.3-25.3 25.3H37.3c-14 0-25.3-11.4-25.3-25.3V38.1c0-14 11.4-25.3 25.3-25.3h60.6c14 0 25.3 11.4 25.3 25.3v60.6z"/>
                <path d="M67.6 33.5c-19.2 0-34.9 15.6-34.9 34.8 0 19.2 15.6 34.9 34.9 34.9 19.2 0 34.9-15.6 34.9-34.9 0-19.1-15.7-34.8-34.9-34.8zm0 57.7C55 91.2 44.8 81 44.8 68.4c0-12.6 10.2-22.9 22.9-22.9s22.9 10.3 22.9 22.9c-.1 12.6-10.4 22.8-23 22.8zM103.9 23.4c-2.3 0-4.6.9-6.2 2.6-1.6 1.6-2.6 3.9-2.6 6.2 0 2.3.9 4.6 2.6 6.2 1.6 1.6 3.9 2.6 6.2 2.6 2.3 0 4.6-.9 6.2-2.6 1.6-1.6 2.6-3.9 2.6-6.2 0-2.3-.9-4.6-2.6-6.2-1.6-1.7-3.8-2.6-6.2-2.6z"/>
              </svg>
            </a>
          </div>
          <div :class="[$style.socialsItem]">
            <a href="https://linkedin.com/company/deed-s.r.l." target="_blank" rel="noopener">
              <svg id="linkedin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13">
                <path d="M0 1.553a1.554 1.554 0 1 0 3.107 0 1.554 1.554 0 0 0-3.107 0zM.214 12.904h2.679v-8.62H.213zM7.178 5.462h-.035V4.285h-2.57v8.62H7.25V8.64c0-1.124.214-2.213 1.607-2.213 1.374 0 1.393 1.286 1.393 2.285v4.193h2.676V8.176c0-2.32-.5-4.106-3.213-4.106-1.303 0-2.177.715-2.535 1.392z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <a
        href="#!"
        @click.prevent="setSubscribe"
        @mouseenter="$hover"
        class="open-subscribe"
      >
        newsletter
      </a>

      <transition @enter="enterNewsletter" @leave="leaveNewsletter">
        <NewsletterForm
          :class="[$style.newsletter]"
          :setSubscribe="setSubscribe"
          :thx="true"
          class="newsletter-form"
          data-subscribe="true"
          v-show="subscribe || sent"
        />
      </transition>
    </div>
  </footer>
</template>

<script>
import gsap from 'gsap'
import { mapState } from 'vuex'
import NewsletterForm from '@/components/NewsletterForm'

export default {
  name: 'footerComponent',


  computed: {
    ...mapState(['global'])
  },

  components: {
    NewsletterForm,
  },

  data() {
    return {
      subscribe: false,
      sent: false,
    };
  },

  methods: {
    setSubscribe(event) {
      if (event === 'sent') {
        this.sent = true;

        setTimeout(() => {
          this.sent = false;
        }, 3000);
      }
      if (typeof event.path !== 'undefined') {
        let paths = event.path.filter(el => typeof el.dataset !== 'undefined' && el.dataset.subscribe);
        if (this.subscribe && paths.length > 0) return;
        if (this.subscribe && (event.target.classList.contains('open-subscribe') || event.target.classList.contains('newsletter-form'))) return;
      }

      this.subscribe = !this.subscribe;

      if (this.subscribe) {
        document.addEventListener('click', this.setSubscribe);
      } else {
        document.removeEventListener('click', this.setSubscribe);
      }
    },

    enterNewsletter(el, done) {
      const tl = new gsap.TimelineMax({ onComplete: done });

      tl.add('start')
      .set(el.children, {
        autoAlpha: 0,
        yPercent: 100,
      })
      .to(el, 0.8, {
        scaleY: 1,
        autoAlpha: 1,
        transformOrigin: '50% 100%',
        ease: gsap.Expo.easeInOut
      }, 'start')
      .to(el.children, 0.8, {
        yPercent: 0,
        autoAlpha: 1,
        ease: gsap.Expo.easeInOut
      }, 'start+=0.5')
    },

    leaveNewsletter(el, done) {
      const delay = this.sent ? 3 : 0;
      const tl = new gsap.TimelineMax({onComplete: done, delay });

      tl.add('start')
      .to(el.children, 1.2, {
        yPercent: 100,
        autoAlpha: 0,
        ease: gsap.Expo.easeOut
      }, 'start')
      .to(el, 1.2, {
        scaleY: 0,
        autoAlpha: 0,
        ease: gsap.Expo.easeOut
      }, 'start')
    },
  },
}
</script>

<style lang="scss" module>
@import "~sass-mq/mq";
@import "../styles/colors";

.footer {
  position: relative;
  width: 100%;
  padding: 30px;
  margin-top: 40px;

  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-flow: column wrap;

  background-color: #000;
  color: #3C3C40;
  font-size: 15px;

  @include mq(s) {
    align-items: flex-start;
    justify-content: space-between;
    flex-flow: row wrap;
    padding: 40px;
  }

  @include mq(md) {
    margin-top: 80px;
  }

  a {
    color: #3C3C40;
    transition: color 0.4s ease-in-out;

    :global(.no-touchevents) &:hover {
      color: white;
    }
  }

  .footerItem:last-child {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;

    a {
      margin-top: 30px;
      transform: translateY(3px);

      @include mq(s) {
        margin-top: 0;
      }
    }
  }
}
.socials {
  visibility: visible;
  opacity: 1;
  transition: all 0.4s ease-out;

  @include mq(md) {
    display: block;
  }

  &.visible {
    opacity: 0;
    visibility: hidden;
    transform: translateY(100%);
  }

  .socialsWrapper {
    display: flex;
    justify-content: center;
    width: auto;

    @include mq(ds) {
      flex-wrap: wrap;
      width: 190px;
    }
  }

  svg {
    padding: absolute;
    top: 0;
    left: 0;

    fill: $color-ui;
    min-width: 14px;
    max-height: 14px;

    transition: fill 0.3s ease-out;

    @at-root .modifier & {
      fill: $color-dark-two;
    }
  }

  .socialsItem {
    width: 14px;
    margin-right: 15px;

    a {
      :global(.no-touchevents) &:hover {
        svg {
          fill: lighten($color-ui, 20%);
        }
      }
    }


    @at-root .modifier & {
      a {
        :global(.no-touchevents) &:hover {
          svg {
            fill: lighten($color-dark-two, 8%);
          }
        }
      }
    }
  }
}
.newsletter {
  background: #000;
  position: absolute;
  overflow: hidden;
  width: 100%;

  @include mq(md) {
    padding-left: 0;
  }
  @include mq(lg) {
    width: 50%;
  }

  right: 0;
  bottom: 0;

  &::v-deep .container {
    background: #000;
  }
}

.hideMobile {
  @include mq($until: sm) {
    opacity: 0;
    height: 0;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterComponent.vue